import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "m-textarea-counter__inner" }
const _hoisted_2 = ["autofocus", "name", "rows", "placeholder", "maxlength", "minlength"]
const _hoisted_3 = { class: "m-textarea-counter__count" }
const _hoisted_4 = {
  key: 0,
  class: "m-textarea_error"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["m-textarea m-textarea-counter", {'m-textarea_error': _ctx.isTooLong}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
        "data-textarea-container": "",
        autofocus: _ctx.autofocus,
        name: _ctx.name,
        rows: _ctx.rows,
        placeholder: _ctx.placeholder,
        maxlength: _ctx.max,
        minlength: _ctx.min,
        onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args)))
      }, null, 40, _hoisted_2), [
        [_vModelText, _ctx.inputValue]
      ]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.count) + " / " + _toDisplayString(_ctx.max), 1)
    ]),
    (!_ctx.isValid)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.isTooLong)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$msg('customer.brief.form.input.error.max', _ctx.max)), 1))
            : _createCommentVNode("", true),
          (_ctx.isTooShort)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$msg('customer.brief.form.input.error.min', _ctx.min)), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}